<router-outlet></router-outlet>
<app-scroll-nav></app-scroll-nav>

<p-toast position="top-right" styleClass="z-[10000]"></p-toast>
<p-confirmDialog key="session-renew-dialog"></p-confirmDialog>

@if (spinner.showState()) {
<app-spinner [texto]="spinner.text() ?? ''"></app-spinner>
}
